import { storyblokEditable } from "@storyblok/react";
import React, { useEffect, useState } from "react";
import Script from "next/script";
import Link from "next/link";


const ContactPartnerWOForm = ({ blok }) => {
 
  return (
    <div className="wrap" style={{ background: `${blok.background}`}}>
      <div
        className="contact-partner-wrap-woform flex inner-wrap"
        {...storyblokEditable(blok)}
        style={{ justifyContent: `${blok.centerContent}`}}
      >
        <div className="contact-img-woform hide-desktop" style={{ display: `${blok.hideImage}` }}>
          <img src={blok.image.filename} alt={blok.image.alt} />
        </div>
        <div className="contact-content-woform flex flex-col ml-8">
          <h2 className="text-2xl">{blok.subheadline}</h2>
          <span>{blok.subline}</span>
          <p>{blok.text}</p>
          <p>{blok.textTwo}</p>
          <div className="contact-partner-button">
          {blok.link && (<Link href={blok.link} ><button>{blok.button}</button></Link>)} 
          {blok.linknewtab && (<Link target="_blank" href={blok.linknewtab} ><button>{blok.buttonnewtab}</button></Link> )}
          </div>

          <img
            className="hide-mobile"
            src={blok.image.filename}
            alt={blok.image.alt}
            style={{ display: `${blok.hideImageMobile}` }}
          />
     
        </div>
      </div>
    </div>
  );
};

export default ContactPartnerWOForm;